<template>
  <div class="ag-page_partners position-relative">
    <ag-card :module="module"></ag-card>
    <ag-partner-modal :selected-partner="selectedPartner" :module="module"></ag-partner-modal>
  </div>
</template>

<script>
/* eslint-disable */
import { computed, defineComponent, ref } from "vue";
import { mapState, mapActions, mapGetters } from "vuex";
import AgCard from "@/components/ag-card/index.vue";
import { GeneralActionTypes } from "@/store/modules/general/action-types";
import { useStore } from "@/store";
import api from "@/api/index";
const store = useStore();
import { notify } from "@kyvg/vue3-notification";
import Partners from "@/helpers/pages/Partners";
import AgLoading from "@/components/ag-loading/index.vue";
import { Roles } from "@/helpers/enums/Roles";
import AgPartnerModal from "@/components/ag-partner-modal/index.vue";
import apiAGSC from "@/store/axiosAgsc";

export default defineComponent({
  name: "Partners",
  components: { AgCard, AgLoading, AgPartnerModal },
  setup() {
    let filter = ref({
      page: 1,
      limit: 5,
      sortColumn: "name",
      sortDir: "asc",
    });
    const module = ref(Partners);

    let action = "add";
    const submitFunction = function (e) {
      if (action === "add") {
        console.log("add");
      } else {
        console.log("edit");
      }
      e.preventDefault();
    };
    const deleteFunction = function (id) {
      const partner = this.partners.find((i) => i.id == id);
      partner.isdeleted = true;
      this.$swal
        .fire({
          title: "Partner Deletion is Currently Disabled",
          icon: "warning",
          text: "For this Release, partner deletion is temporarily postponed to avoid some complications possibly occur with it's corresponding users, companies, sites, groups, endpoints, events and alerts.",
          showCancelButton: false,
          confirmButtonText: "OK",
        })
        .then((result) => {
          return;
          if (result.isConfirmed) {
            apiAGSC
              .post("Partner/CreateOrEdit", partner)
              .then((res) => {
                if (
                  Number(res.data.statusCode) == 200 ||
                  Number(res.data.status) == 200
                ) {
                  notify({
                    title: "Deleted!",
                    type: "success",
                    text: "The partner has been deleted.",
                    duration: 5000,
                  });
                } else {
                  this.$swal.fire("Error", res.data.Errors, "error");
                }
              })
              .catch((e) => {
                this.$swal.fire("Error", JSON.stringify(e.Message), "error");
              })
              .finally(() => {
                const options = this.module.component.options;
                options.page = 1;
                store.dispatch(GeneralActionTypes.GET_PARTNERS, {
                  options: options,
                  filters: {},
                });
              });
          }
        });
    };

    const editFunction = async function (id) {
      action = "edit";
      const res = await api.partners.getById(id);
      this.selectedPartner = res.data.entityData;
    };

    const reloadFunction = function (id) {
      console.log("reloadFunction");
    };

    const getList = (
      filters = filter.value,
      options = module.value.component.options
    ) => {
      const body = { filters, options };
      store.dispatch(GeneralActionTypes.GET_PARTNERS, body);
    };

    const searchWithFilters = (param) => {
      filter.value.name =
        module.value.filter.filters.filter((x) => x.param == "name")[0]
          .vmodel || "";
      filter.value.shortName =
        module.value.filter.filters.filter((x) => x.param == "shortName")[0]
          .vmodel || "";
      filter.value.contactName =
        module.value.filter.filters.filter((x) => x.param == "contactName")[0]
          .vmodel || "";
      filter.value.contactPhone =
        module.value.filter.filters.filter((x) => x.param == "contactPhone")[0]
          .vmodel || "";
      filter.value.contactEmail =
        module.value.filter.filters.filter((x) => x.param == "contactEmail")[0]
          .vmodel || "";

      const filters = filter.value;
      const options = module.value.component.options;
      module.value.readyToUseFilters = filters;
      getList(filters, options);
    };

    const resetFilters = () => {
      module.value.filter.filters.forEach((item) => {
        item.vmodel = null;
      });

      searchWithFilters(true);
      let query = Object.assign({}, router.currentRoute.value.query);
      delete query.searchResults;
      router.replace({ query });
    };

    return {
      searchWithFilters,
      resetFilters,
      getList,
      deleteFunction,
      editFunction,
      reloadFunction,
      submitFunction,
    };
  },
  data() {
    return {
      module: Partners,
      currentPartners: [],
      selectedPartner: null,
      value: [],
      Roles: Roles,
    };
  },
  computed: {
    partners() {
      return store.state.general.partners;
    },
    ...mapGetters(["partners"]),
  },
  watch: {
    partners(data) {
      this.module.component.options.rows = data;
    },
  },
  mounted() {
    const filters = this.filter;
    const options = this.module?.component?.options;
    this.getList(filters, options);
  },
});
</script>

<style>
.ag-page_partners #ag-table .ag-icon {
  font-size: 1.1em !important;
}
</style>